import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import ContratoService from '../../../../../services/contrato-auth';
import { Link } from 'react-router-dom';



const FormBusca = (props) => {
    const [processo, setProcesso] = useState("");
    const [ano, setAno] = useState("");



    const busca = async (query) => {
        if (query === "") {
            await props.fetchContratos()
            setAno("")
            setProcesso("")
        } else {
            var response = await ContratoService.buscar(query)
            if (response.data.length >= 1) {
                props.setContratos(response.data)
                props.setVazio(false)
                setAno("")
                setProcesso("")
            } else {
                props.setVazio(true)
                setAno("")
                setProcesso("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (processo) prepQuery = prepQuery + `&processo=${processo}`;
        if (ano) prepQuery = prepQuery + `&ano=${ano}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="Número">
                                <FloatingLabel
                                    label="Número do Processo (sem ano)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="processo"
                                        value={processo}
                                        onChange={e => setProcesso(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano do Processo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/contratos'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca